


























import { Component, Vue } from 'vue-property-decorator';

import version from '@/version.txt';

@Component
export default class FullscreenLayout extends Vue {
  version = version;
}
